import {PayloadAction} from '@reduxjs/toolkit';
//types
import {IContributionResponse, IOrganizationAttendeesContributionsReducer} from '../../utils/types';

export const pendingOperation = (state: IOrganizationAttendeesContributionsReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IOrganizationAttendeesContributionsReducer) => {
	state.isLoading = false;
};

export const getAttendeeContributionOperation = (
	state: IOrganizationAttendeesContributionsReducer,
	{payload}: PayloadAction<IContributionResponse>
) => {
	state.attendeeContributions = payload;
	state.isLoading = false;
};
